import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  ButtonGroup,
  Button,
  Tooltip,
} from "@mui/material"
import { Tabs, Tab } from "react-bootstrap"
import LinearProgress from "@mui/material/LinearProgress"
import EditPermissionsTransferList from "./EditPermissionsTransferList"
import api from "../../services/AuthApi"
import Helpers from "../../utils/Helpers"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import InfoIcon from "@mui/icons-material/Info"
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling"
import Alerts from "../../errorHandeling/Alerts"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import UserLevels from "./UserLevels"

const EditRoleModal = ({
  open,
  onClose,
  roleData,
  existingRole,
  setIsPendingChange,
}) => {
  const [data, setData] = useState([])
  const [permList, setPermList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isBtnLoading, setIsBtnLoading] = useState(false)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [selectedOptions, setSelectedOptions] = useState([])
  const [deletedPerms, setDeletedPerms] = useState([])

  const handleToggle = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option))
    } else {
      setSelectedOptions([...selectedOptions, option])
    }
  }

  const isOptionSelected = (option) => {
    return selectedOptions.includes(option)
  }

  useEffect(() => {
    setData(roleData)
  }, [roleData])

  useEffect(() => {
    const arr = selectedOptions?.map((p) => {
      return { permission: p }
    })
    setDeletedPerms(arr)
  }, [selectedOptions])

  const handleChange = (e) => {
    const value = e.target.value
    setData({
      ...data,
      [e.target.name]: value,
    })
    setIserror(false)
    setErrorMessages([])
  }

  const handleClear = () => {
    setTimeout(() => {
      setIsSuccess(false)
      setSuccessMessages([""])
      setIserror(false)
      setErrorMessages([])
      onClose()
      setIsPendingChange(true)
    }, 5000)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)
    const payload = {
      updatedRolePerms: [
        {
          existingRole: existingRole,
          updatedRole: data.role === existingRole ? null : data?.role,
          level: data?.level,
          desc: data?.desc,
          addedPermissions: permList,
          deletedPermissions: deletedPerms ? deletedPerms : null,
        },
      ],
    }
    api
      .put("/role/permissions", payload)
      .then((res) => {
        setIsBtnLoading(false)
        setIsLoading(false)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClear()
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsLoading(false)
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        )
        handleClear()
      })
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="true"
      open={open}
      PaperProps={{
        style: { borderRadius: "10px", width: "912px", margin: 0 },
      }}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#116c6f",
          color: "white",
          position: "fixed",
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "10px",
          width: "912px",
          zIndex: 1000,
        }}>
        Edit Role
        <IconButton
          aria-label="cancel"
          sx={{ color: "#fff" }}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <br />
      {isLoading && <LinearProgress />}
      <form onSubmit={handleSubmit}>
        <DialogContent
          dividers
          sx={{
            marginTop: 3,
            paddingTop: 4,
          }}>
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <div>
            <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
              <TextField
                value={data?.role}
                name="role"
                type="text"
                variant="outlined"
                color="secondary"
                label="Role"
                fullWidth
                required
                sx={{ mb: 4 }}
                onChange={handleChange}
              />
              <UserLevels data={data} handleChange={handleChange} />
            </Stack>
            <TextField
              value={data?.desc}
              name="desc"
              type="text"
              variant="outlined"
              color="secondary"
              label="Description"
              fullWidth
              required
              sx={{ mb: 4 }}
              onChange={handleChange}
            />
            <br />
            <br />
            <Tabs
              defaultActiveKey="Remove"
              id="uncontrolled-tab-example"
              className="mb-3">
              <Tab eventKey="Remove" title="Remove Permissions">
                <br />
                <h6>
                  Remove Permissions &nbsp;
                  <Tooltip title="Select current permissions you need to remove and update">
                    <InfoIcon fontSize="small" />
                  </Tooltip>
                </h6>
                <br />
                <div>
                  <Stack
                    spacing={{ xs: 1, sm: 2 }}
                    direction="row"
                    useFlexGap
                    flexWrap="wrap"
                    alignItems="center">
                    {data?.permissions?.map((p) => (
                      <ButtonGroup key={p.permission}>
                        <Button
                          variant={
                            isOptionSelected(p.permission)
                              ? "contained"
                              : "outlined"
                          }
                          color={
                            isOptionSelected(p.permission) ? "error" : "success"
                          }
                          onClick={() => handleToggle(p.permission)}
                          active={isOptionSelected(p.permission)}
                          endIcon={
                            isOptionSelected(p.permission) ? (
                              <CheckBoxIcon />
                            ) : (
                              <CheckBoxOutlineBlankIcon />
                            )
                          }>
                          {Helpers.underscorePermFormat(p.permission)}
                        </Button>
                      </ButtonGroup>
                    ))}
                  </Stack>
                  <br />
                </div>
              </Tab>
              <Tab eventKey="Edit" title="Add Permissions">
                <br />
                <h6>
                  Add New Permissions &nbsp;
                  <Tooltip title="Select new permissions you need to add and update">
                    <InfoIcon fontSize="small" />
                  </Tooltip>
                </h6>
                <br />

                <EditPermissionsTransferList
                  permissions={data?.permissions}
                  setPermList={setPermList}
                />
              </Tab>
            </Tabs>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}>
            Update
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default EditRoleModal
